import { render, staticRenderFns } from "./CrowdloanCard.vue?vue&type=template&id=0be34126&scoped=true&"
import script from "./CrowdloanCard.vue?vue&type=script&lang=js&"
export * from "./CrowdloanCard.vue?vue&type=script&lang=js&"
import style0 from "./CrowdloanCard.vue?vue&type=style&index=0&id=0be34126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be34126",
  null
  
)

export default component.exports